import { Color, Size, Spacing, Transition } from '@opallabs/gem'

const fill = ({ color = null, theme, width }) => ({
  backgroundColor: color || Color[theme].Surface.A200,
  blockSize: Spacing.XS,
  borderRadius: Size.Rounding,
  inlineSize: width,
  insetInlineStart: 0,
  position: 'absolute',
  ...Transition(['inline-size']),
})

const base = (style) => ({
  backgroundColor: Color.dark.Surface.N400,
  border: `2px solid ${Color.dark.Surface.N400}`,
  borderRadius: Size.Rounding,
  blockSize: Spacing.XS,
  position: 'relative',
  inlineSize: '100%',
  ...style,
})

export const styles = {
  base,
  fill,
}
